import EditRewardAvailabilityModal, {
  RolePlatformAvailabilityForm,
} from "./EditRewardAvailabilityModal"

export default EditRewardAvailabilityModal
export type { RolePlatformAvailabilityForm }
